import React from 'react';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//components:
import IntNumberFormatInput from '../../../components/int_number_input_formatter';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Tooltip, Fade } from '@material-ui/core';


const styles = theme => ({
    root: {
        height: '100%',
        width: 240
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    checkbox: {
        marginBottom: 0,
        paddingTop: 25,
        width: 215,
    },
    buttonsContainer: {
        width: 520,
        padding: '25px 0 0 25px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    margin: {
        marginTop: 10,
    },
    rtl: {
        textAlign: 'right',
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
});

class EditCvTipoArticulo extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            id: this.props.cvTipoArticulo.id ? this.props.cvTipoArticulo.id : uuidv4(),
            descr: this.props.cvTipoArticulo.descr ? this.props.cvTipoArticulo.descr : '',
            isMovCaja: this.props.cvTipoArticulo.isMovCaja ? this.props.cvTipoArticulo.isMovCaja : false,
            iKind: this.props.cvTipoArticulo.iKind ? this.props.cvTipoArticulo.iKind : 0,
            iTipoZona: this.props.cvTipoArticulo.iTipoZona !== undefined ? this.props.cvTipoArticulo.iTipoZona : this.props.tiposZona[0].id,
            cvTipoZonaDescr: this.props.cvTipoArticulo.cvTipoZonaDescr ? this.props.cvTipoArticulo.cvTipoZonaDescr : this.props.tiposZona[0].descr,
        };

    };

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });

    };

    handleCheckbox = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.checked });
    };


    handleChangeSelect = event => {

        const value = parseInt(event.target.value);

        this.setState({
            ...this.state,
            iTipoZona: value,
            cvTipoZonaDescr: this.props.tiposZona.find(tz => tz.id === value).descr
        });
    };


    fillSelectOptionList = () => {

        return this.props.tiposZona.map(tz => {

            return (
                <option key={tz.id} value={tz.id}>{tz.descr}</option>
            );

        });

    };


    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <Tooltip title="Zona generalmente asociada a ester producto" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                            <TextField
                                id={'descr'}
                                label={'Descripción'}
                                placeholder={'Descripción'}
                                className={classes.textField}
                                margin="normal"
                                autoFocus
                                value={this.state.descr}
                                onChange={(event) => this.handleValueChange(event, 'descr')}
                            />
                        </Tooltip>
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="tipos-zona-placeholder">
                            Tipo Zona
                    </InputLabel>
                        <Select
                            native
                            value={this.state.iTipoZona}
                            onChange={(event) => this.handleChangeSelect(event)}
                            name={'cvTipoZonaDescr'}
                        >
                            {this.fillSelectOptionList()}
                        </Select>
                    </FormControl>
                </div>

                <div className={`${classes.containerPair} ${classes.margin}`}>
                    <FormControl className={classes.checkbox}>
                        <Tooltip title="Indica si es un concepto de caja (cobro/pago) o no (ingreso/gasto)" TransitionComponent={Fade} placement="top" TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                            <FormControlLabel
                                style={{ marginLeft: 8 }}
                                control={
                                    <Checkbox
                                        checked={this.state.isMovCaja ? true : false}
                                        onChange={event => this.handleCheckbox(event, "isMovCaja")}
                                        value={'isMovCaja'}
                                        color="secondary"
                                    />
                                }
                                label="¿Movimiento de caja?"
                            />
                        </Tooltip>
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <TextField
                            id={'iKind'}
                            label={'iKind'}
                            placeholder={'iKind'}
                            margin="normal"
                            InputProps={{ classes: { input: classes.rtl }, inputComponent: IntNumberFormatInput }}
                            value={this.state.iKind}
                            onChange={(event) => this.handleValueChange(event, 'iKind')}
                        />
                    </FormControl>


                </div>

                <div className={classes.buttonsContainer}>
                    <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                    <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                        const tipoArticulo = {
                            id: this.state.id,
                            descr: this.state.descr,
                            isMovCaja: this.state.isMovCaja ? 1 : 0,
                            iKind: this.state.iKind || 0,
                            iTipoZona: this.state.iTipoZona,
                            cvTipoZonaDescr: this.state.cvTipoZonaDescr
                        };

                        if (this.props.checkCvTipoArticulo(tipoArticulo)) {

                            this.props.okHandler(tipoArticulo);
                            this.props.hideDialog();
                        };
                    }}>Guardar</Button>
                </div>
            </div>
        );
    };

};

EditCvTipoArticulo.propTypes = {
    cvTipoArticulo: PropTypes.object.isRequired,
    checkCvTipoArticulo: PropTypes.func.isRequired,
    tiposZona: PropTypes.array.isRequired,
    okHandler: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};


export default withStyles(styles, { withTheme: true })(EditCvTipoArticulo);